var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-permission"},[_c('i',{staticClass:"el-icon-lock"}),_c('h2',[_vm._v("无访问权限")]),_c('p',[_vm._v("当前账号的角色没有该页面的权限，请联系管理员在「角色管理」中分配。")]),_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":_vm.handleLogout}},[_vm._v("退出登录")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }